import React, { useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import SupportPopup from 'apps/auth/components/utils/popup/SupportPopup';
import { PLUS_UPDATE_PAYMENT_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    AUTH_PLUS_RENEW_SUBSCRIBE_ACTION,
    AUTH_PLUS_SUBSCRIBE_PLAN_UPDATE_SCREEN,
    AUTH_PLUS_SUBSCRIBE_UPDATE_SCREEN,
    AUTH_PLUS_UNSUBSCRIBE_SCREEN,
} from 'apps/auth/constants/UrlConstants';
import { useExtra } from 'apps/auth/hooks/selectors';

import HowItWorksModal from './HowItWorksModal';
import HowItWorksModalForEmployee from './HowItWorksModalForEmployee';
import SubscriptionUpdateRestrictionPopup from './SubscriptionUpdateRestrictionPopup';
import PaysendPlusPrecheckPopup from '../subscription/PaysendPlusPrecheckPopup';
import { CARD_TO_SUBSCRIPTION } from '../utils';

const ShowMorePopup = (props) => {
    const submitRef = useRef(null);
    const { subscriptionInfo, subscriptionTariffs, isPaysendEmployee } = useExtra();

    const getSelectedCard = (subscriptionPaymentInfo) => {
        if (subscriptionPaymentInfo?.payMethodId === CARD_TO_SUBSCRIPTION) {
            return subscriptionPaymentInfo?.addInfo.payment_method_details;
        }
        return null;
    };

    const getSelectedTariff = () => {
        return subscriptionTariffs.find((t) => t.id === subscriptionInfo?.planId);
    };

    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            {!props.isSubscriptionExpired && props.isCancelled && (
                <PopupButton
                    iconName="plus-rounded"
                    text={props.renewSubscription}
                    onClick={() => {
                        props.popupRef?.current?.close();
                        props.popupRef?.current?.open(
                            <PaysendPlusPrecheckPopup
                                popupRef={props.popupRef}
                                actionType={'renew'}
                                tariff={getSelectedTariff()}
                                action={AUTH_PLUS_RENEW_SUBSCRIBE_ACTION}
                                submitRef={submitRef}
                                cardEncodedInfo={''}
                                selectedCard={getSelectedCard(subscriptionInfo)}
                            />,
                        );
                    }}
                />
            )}
            <PopupButton
                iconName="info-rounded"
                text={props.howItWorks}
                onClick={() => {
                    props.toggleModal(
                        true,
                        isPaysendEmployee ? <HowItWorksModalForEmployee popupRef={props.popupRef} /> : <HowItWorksModal popupRef={props.popupRef} />,
                    );
                    props.popupRef?.current?.close();
                }}
            />
            {!props.isSubscriptionExpired && !props.isCancelled && (
                <>
                    {!isPaysendEmployee && (
                        <>
                            <PopupButton
                                iconName="card"
                                text={props.updatePaymentMethod}
                                href={AUTH_PLUS_SUBSCRIBE_UPDATE_SCREEN}
                                onClick={() => {
                                    amplitude.getInstance().logEvent(PLUS_UPDATE_PAYMENT_CLICKED);
                                    props.popupRef?.current?.close();
                                }}
                            />
                            <PopupButton
                                iconName="calendar"
                                text={props.updateSubscriptionPlan}
                                href={!props.isUpdateRestricted ? AUTH_PLUS_SUBSCRIBE_PLAN_UPDATE_SCREEN : null}
                                onClick={() => {
                                    props.popupRef?.current?.close();
                                    if (props.isUpdateRestricted) {
                                        props.popupRef?.current?.open(
                                            <SubscriptionUpdateRestrictionPopup
                                                text={props.subscriptionUpdateRestriction}
                                                buttonText={props.gotIt}
                                                popupRef={props.popupRef}
                                            />,
                                        );
                                    }
                                }}
                            />
                        </>
                    )}
                    <PopupButton
                        iconName="cross"
                        href={AUTH_PLUS_UNSUBSCRIBE_SCREEN}
                        text={props.cancelSubscription}
                        onClick={() => {
                            props.popupRef?.current?.close();
                        }}
                    />
                </>
            )}
            <PopupButton
                iconName="lifebuoy"
                text={props.support}
                onClick={(e) => {
                    e.preventDefault();
                    props.popupRef?.current?.close();
                    props.popupRef?.current?.open(<SupportPopup popupRef={props.popupRef} />);
                }}
            />
        </SimplePopup>
    );
};
ShowMorePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    renewSubscription: PropTypes.string,
    howItWorks: PropTypes.string,
    updatePaymentMethod: PropTypes.string,
    cancelSubscription: PropTypes.string,
    support: PropTypes.string,
    isSubscriptionExpired: PropTypes.bool,
    isCancelled: PropTypes.bool,
};
export default connect(null, { toggleModal })(ShowMorePopup);
